/**
 * Canonical enum values shared by web and api.
 * Values mirror the Prisma enums in apps/api/prisma/schema.prisma —
 * keep both in sync when adding values.
 */

export const USER_ROLES = ['ADMIN', 'INSTRUCTOR', 'LEARNER', 'COMPANY_CONTACT'] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const PROGRAM_TYPES = [
  'GROUP',
  'PRIVATE',
  'CORPORATE',
  'CHILDREN',
  'ONLINE',
  'BOOTCAMP',
] as const;
export type ProgramType = (typeof PROGRAM_TYPES)[number];

export const SKILL_TYPES = [
  'SPEAKING',
  'LISTENING',
  'GRAMMAR',
  'VOCABULARY',
  'READING',
  'WRITING',
  'PRONUNCIATION',
] as const;
export type SkillType = (typeof SKILL_TYPES)[number];

export const LEARNER_LEVELS = [
  'BEGINNER',
  'ELEMENTARY',
  'INTERMEDIATE',
  'UPPER_INTERMEDIATE',
  'ADVANCED',
] as const;
export type LearnerLevel = (typeof LEARNER_LEVELS)[number];

export const RESOURCE_TYPES = [
  'ACTIVITY',
  'ARTICLE',
  'VIDEO',
  'AUDIO',
  'WORKSHEET',
  'SPEAKING_DRILL',
  'QUIZ',
] as const;
export type ResourceType = (typeof RESOURCE_TYPES)[number];

export const RESOURCE_ACCESS_LEVELS = ['FREE', 'ACCOUNT'] as const;
export type ResourceAccess = (typeof RESOURCE_ACCESS_LEVELS)[number];

export const AUDIENCE_TYPES = ['ADULTS', 'STUDENTS', 'CHILDREN', 'PROFESSIONALS'] as const;
export type AudienceType = (typeof AUDIENCE_TYPES)[number];

export const DURATION_BANDS = ['MIN_0_5', 'MIN_5_10', 'MIN_10_20', 'MIN_20_PLUS'] as const;
export type DurationBand = (typeof DURATION_BANDS)[number];

export const INQUIRY_TYPES = ['GENERAL', 'CONSULTATION', 'PLACEMENT_TEST', 'CORPORATE'] as const;
export type InquiryType = (typeof INQUIRY_TYPES)[number];

export const INQUIRY_STATUSES = [
  'NEW',
  'CONTACTED',
  'IN_PROGRESS',
  'CONVERTED',
  'CLOSED',
] as const;
export type InquiryStatus = (typeof INQUIRY_STATUSES)[number];

export const INQUIRY_PRIORITIES = ['LOW', 'NORMAL', 'HIGH'] as const;
export type InquiryPriority = (typeof INQUIRY_PRIORITIES)[number];

export const MEDIA_VISIBILITIES = ['PUBLIC', 'PRIVATE'] as const;
export type MediaVisibility = (typeof MEDIA_VISIBILITIES)[number];

export const LEARNING_MODES = ['IN_PERSON', 'ONLINE', 'HYBRID'] as const;
export type LearningMode = (typeof LEARNING_MODES)[number];

export const POST_STATUSES = ['DRAFT', 'PUBLISHED'] as const;
export type PostStatus = (typeof POST_STATUSES)[number];

export const BLOG_CATEGORIES = [
  'SPEAKING_CONFIDENCE',
  'ENGLISH_FOR_WORK',
  'ENGLISH_FOR_RWANDA',
  'LEARNING_TIPS',
  'BUSINESS_ENGLISH',
  'CHILDREN_LEARNING',
  'TECHNOLOGY_IN_LEARNING',
] as const;
export type BlogCategory = (typeof BLOG_CATEGORIES)[number];

export const ANALYTICS_EVENT_TYPES = [
  'PAGE_VIEW',
  'CTA_CLICK',
  'FORM_SUBMIT',
  'RESOURCE_VIEW',
  'PROGRAM_VIEW',
] as const;
export type AnalyticsEventType = (typeof ANALYTICS_EVENT_TYPES)[number];
